import {
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_ERROR,
  UPDATE_CONFIG,
  UPDATE_AUTO_REFRESH_CONFIG,
} from "./constants";

export function triggerLogout(data) {
  return {
    type: LOGOUT,
    data,
  };
}

export function triggerLogoutSuccess(data) {
  return {
    type: LOGOUT_SUCCESS,
    data,
  };
}

export function triggerLogoutError(error) {
  return {
    type: LOGOUT_ERROR,
    error,
  };
}

export function updateConfig(config) {
  return {
    type: UPDATE_CONFIG,
    config,
  };
}

export function updateAutoRefreshConfig(autoRefreshConfig) {
  return {
    type: UPDATE_AUTO_REFRESH_CONFIG,
    autoRefreshConfig,
  };
}
